// extracted by mini-css-extract-plugin
export default {"row":"index_row__oTsLI","button":"index_button__pFWJx"};